import { render, staticRenderFns } from "./fenceDataList.vue?vue&type=template&id=bf1832b0&scoped=true"
import script from "./fenceDataList.vue?vue&type=script&lang=js"
export * from "./fenceDataList.vue?vue&type=script&lang=js"
import style0 from "./fenceDataList.vue?vue&type=style&index=0&id=bf1832b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf1832b0",
  null
  
)

export default component.exports